import React from "react";
import styled from "styled-components";
import { NavLink, Switch, Route, Redirect } from "react-router-dom";

import { gradients, GridWrapper, Banner, FromTopPage } from "../theme";
import Layout from "../components/annexes/AnnexesLayout";
import Manifesto from "../components/annexes/AnnexesManifesto";
import Status from "../components/annexes/AnnexesStatus";
import Rules from "../components/annexes/AnnexesRules";
import CGU from "../components/annexes/AnnexesCGU";
import Legal from "../components/annexes/AnnexesLegal";

const Header = styled(Banner)`
  margin-bottom: 65px;

  @media (max-width: 1023px) {
    margin-bottom: 45px;
  }

  > div {
    display: block;
    padding: 112px 0 0;

    @media (max-width: 767px) {
      padding-top: 50px;
    }
  }

  h1 {
    font-size: 4.8rem;
    font-weight: 500;
    letter-spacing: -0.1rem;
    margin-bottom: 52px;
    text-transform: none;

    @media (max-width: 767px) {
      margin-bottom: 30px;
    }
  }

  nav {
    display: flex;
    justify-content: space-between;
    width: 100%;

    @media (max-width: 767px) {
      display: block;
    }
  }

  a {
    border-left: 4px solid white;
    color: white;
    display: inline-block;
    font-size: 1.2rem;
    font-weight: 600;
    height: 61px;
    letter-spacing: 0.02rem;
    padding-left: 10px;
    position: relative;
    text-decoration: none;
    transition: 0.3s;
    width: calc(100% / 6 - 10px);

    :before {
      background: ${gradients.purpleToPink("to bottom")};
      content: "";
      height: 0;
      left: -4px;
      position: absolute;
      top: 0;
      transition: 0.3s;
      width: 4px;
    }

    :hover,
    &.active {
      margin-top: -10px;
      height: 71px;

      :before {
        height: 90px;
      }
    }

    @media (max-width: 1023px) {
      text-align: left;
    }

    @media (max-width: 767px) {
      display: block;
      height: auto;
      padding: 12px 12px 24px;
      width: 100%;

      :hover,
      &.active {
        margin: 0;
        height: auto;

        :before {
          height: 100%;
        }
      }
    }
  }
`;

function Annexes() {
  return (
    <FromTopPage>
      <Header>
        <GridWrapper>
          <h1>À propos</h1>
          <nav>
            <NavLink to="/annexes/manifeste">
              Manifeste pour un média citoyen
            </NavLink>
            <NavLink to="/annexes/statuts">Statuts</NavLink>
            <NavLink to="/annexes/reglement-interieur">
              Règlement intérieur
            </NavLink>
            <NavLink to="/annexes/cgu">
              Conditions générales d'utilisation
            </NavLink>
            <NavLink to="/annexes/mentions-legales">Mentions légales</NavLink>
            <a href="mailto:contact@lemediatv.fr">Contact</a>
          </nav>
        </GridWrapper>
      </Header>
      <Switch>
        <Route path="/annexes/manifeste">
          <Layout title="Manifeste pour un média citoyen">
            <Manifesto />
          </Layout>
        </Route>
        <Route path="/annexes/statuts">
          <Layout title="Statuts">
            <Status />
          </Layout>
        </Route>
        <Route path="/annexes/reglement-interieur">
          <Layout title="Règlement intérieur">
            <Rules />
          </Layout>
        </Route>
        <Route path="/annexes/cgu">
          <Layout title="Conditions générales d'utilisation">
            <CGU />
          </Layout>
        </Route>
        <Route path="/annexes/mentions-legales">
          <Layout title="Mentions légales">
            <Legal />
          </Layout>
        </Route>
        <Redirect to="/annexes/manifeste" />
      </Switch>
    </FromTopPage>
  );
}

export default Annexes;
